import { Navigate } from 'react-router-dom';

import { useIsSelectBoat } from '@/entities/boat';
import { useRoutes } from '@/entities/navigation';

const HomeDefaultComponent = () => {
	const isSelectedBoat = useIsSelectBoat();
	const { multiView, singleView } = useRoutes();

	if (isSelectedBoat) {
		return <Navigate to={singleView} />;
	}

	return <Navigate to={multiView} />;
};

export default HomeDefaultComponent;
